import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface MiniStoriesContentCardEntityParams {
  forward_url: string;
  video_upload_url: string;
}
export class MiniStoriesContentCardEntity extends BaseEntityClass {
  asset_type: string;
  forward_url: string;

  constructor(params: MiniStoriesContentCardEntityParams) {
    super();
    this.type = "mini_stories_content_card";
    this.entity_version = 3;
    this.asset_type = params.video_upload_url ? "video" : "image";
    this.forward_url = params.forward_url;
  }
}
